import React from 'react'
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic'
import { Routes, Route } from 'react-router-dom'
import { AuthenticatedRoute } from '../../shared/routing/AuthenticatedRoute'
import { CompanySettingsContainer } from './company-settings/CompanySettingsContainer'
import { PrintSettingsContainer } from './print-settings/PrintSettingsContainer'
import { UsersListContainer } from './users/UsersListContainer'
import { PicturesContainer } from './pictures/PicturesContainer'
import { SalePlacesListContainer } from './sale-places/SalePlacesListContainer'
import { FiscalizationSettingsContainer } from './fiscalization/FiscalizationSettingsContainer'
import { EInvoiceSettingsContainer } from './e-invoice/EInvoiceSettingsContainer'
import { useOfferionTranslation } from '../../shared/store/hooks/useOfferionTranslation'

export const SettingsContainer = () => {
    const { t } = useOfferionTranslation()

    return (
        <>
            <BreadcrumbsItem to="/settings">{t('Settings.Header.pageTitle')}</BreadcrumbsItem>

            <Routes>
                <Route path="/" element={<AuthenticatedRoute element={<CompanySettingsContainer />} />} />
                <Route path="/print" element={<AuthenticatedRoute element={<PrintSettingsContainer />} />} />
                <Route path="/users" element={<AuthenticatedRoute element={<UsersListContainer />} />} />
                <Route path="/pictures" element={<AuthenticatedRoute element={<PicturesContainer />} />} />
                <Route path="/sale-places" element={<AuthenticatedRoute element={<SalePlacesListContainer />} />} />
                <Route path="/fiscalization" element={<AuthenticatedRoute element={<FiscalizationSettingsContainer />} />} />
                <Route path="/e-invoice" element={<AuthenticatedRoute element={<EInvoiceSettingsContainer />} />} />
            </Routes>
        </>
    )
}
